// extracted by mini-css-extract-plugin
export default {"propertiesModal":"DesktopDetails_propertiesModal__+WLta","addReview":"DesktopDetails_addReview__tnWzV"};